import React, { Component, Suspense } from "react";
import Layout from "./components/Layout";
import { Route, Switch, BrowserRouter as Router, withRouter } from "react-router-dom";

// Import Css
import "./assets/css/materialdesignicons.min.css";
import "./Apps.scss";

import "./assets/css/colors/default.css";

// Include Routes
import routes from "./routes";
import { QueryClient, QueryClientProvider } from "react-query";

function withLayout(WrappedComponent: any, hasDarkTopBar: any) {
    // ...and returns another component...
    return class extends React.Component {
        render() {
            return (
                <Layout hasDarkTopBar={hasDarkTopBar}>
                    <WrappedComponent></WrappedComponent>
                </Layout>
            );
        }
    };
}
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
const App = () => {
    const Loader = () => {
        return (
            <div id="preloader">
                <div id="status">
                    <div className="spinner">
                        <div className="double-bounce1"></div>
                        <div className="double-bounce2"></div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <React.Fragment>
            <QueryClientProvider client={queryClient} contextSharing={true}>
                <Router>
                    <Suspense fallback={Loader()}>
                        <Switch>
                            {routes.map((route, idx) =>
                                route.isWithoutLayout ? (
                                    <Route path={route.path} exact={route.exact} component={route.component} key={idx} />
                                ) : (
                                    <Route path={route.path} exact component={withLayout(route.component, route.isTopbarDark)} key={idx} />
                                ),
                            )}
                        </Switch>
                    </Suspense>
                </Router>
                {/* <ReactQueryDevtools /> */}
            </QueryClientProvider>
        </React.Fragment>
    );
};

export default withRouter(App);
